const TOKEN_KEY = 'lc_admin_token'
const EXPIRES_AT_KEY = 'lc_admin_expires_at'

function parseJwtPayload(token) {
  try {
    const part = token.split('.')[1]
    if (!part) return null
    const base64 = part.replace(/-/g, '+').replace(/_/g, '/')
    const json = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
        .join('')
    )
    return JSON.parse(json)
  } catch {
    return null
  }
}

export function saveAuth(accessToken, expiresInSeconds) {
  if (!accessToken || typeof accessToken !== 'string') {
    throw new Error('无效的 accessToken')
  }
  const expiresAt = Date.now() + Number(expiresInSeconds) * 1000
  localStorage.setItem(TOKEN_KEY, accessToken)
  localStorage.setItem(EXPIRES_AT_KEY, String(expiresAt))
}

export function clearAuth() {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(EXPIRES_AT_KEY)
}

export function getToken() {
  const token = localStorage.getItem(TOKEN_KEY)
  if (!token) return null

  const payload = parseJwtPayload(token)
  if (!payload) {
    clearAuth()
    return null
  }

  const jwtExpMs = payload.exp ? payload.exp * 1000 : 0
  const storedExpMs = Number(localStorage.getItem(EXPIRES_AT_KEY) || '0')
  const expiresAt = jwtExpMs > 0 && storedExpMs > 0 ? Math.min(jwtExpMs, storedExpMs) : jwtExpMs || storedExpMs

  if (expiresAt > 0 && Date.now() >= expiresAt) {
    clearAuth()
    return null
  }
  if (expiresAt <= 0) {
    clearAuth()
    return null
  }
  return token
}

export function isAuthenticated() {
  return Boolean(getToken())
}

/** 仅允许站内 hash 路由路径，防止开放重定向 */
export function sanitizeRedirect(redirect) {
  if (typeof redirect !== 'string') return null
  const path = redirect.trim()
  if (!path.startsWith('/') || path.startsWith('//') || path.includes('://')) {
    return null
  }
  return path
}
